import { render, staticRenderFns } from "./Modal-noti.vue?vue&type=template&id=01b7b94a&scoped=true"
import script from "./Modal-noti.vue?vue&type=script&lang=js"
export * from "./Modal-noti.vue?vue&type=script&lang=js"
import style0 from "./Modal-noti.vue?vue&type=style&index=0&id=01b7b94a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b7b94a",
  null
  
)

export default component.exports